export default function LimitReachedNotificationIcon() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.9261 7.54545L16.7045 19.9801H14.3438L14.1222 7.54545H16.9261ZM15.5284 25.1619C15.0568 25.1619 14.6534 24.9972 14.3182 24.6676C13.983 24.3324 13.8182 23.929 13.8239 23.4574C13.8182 22.9915 13.983 22.5938 14.3182 22.2642C14.6534 21.929 15.0568 21.7614 15.5284 21.7614C15.9886 21.7614 16.3864 21.929 16.7216 22.2642C17.0568 22.5938 17.2273 22.9915 17.233 23.4574C17.2273 23.7699 17.1449 24.0568 16.9858 24.3182C16.8324 24.5739 16.6278 24.7784 16.3722 24.9318C16.1165 25.0852 15.8352 25.1619 15.5284 25.1619Z'
        fill='#DA0808'
      />
    </svg>
  );
}
